export default __webpack_public_path__ + "static/media/workouttimes_6@3x.931879c4.jpg";